import type { KnowledgeLives } from '@thom/folio-domain/core/ports/knowledge'
import { filterFor } from '@thom/pb/filter-builder'
import { COLLECTION, fromRecord } from './knowledge-adapter'
import type { Realtime } from './realtime'

const byId = (id: string) => filterFor<{ id: string }>()([{ field: 'id', comparator: 'eq', value: id }])

const createKnowledgeLives = ({ client, connection }: Realtime): KnowledgeLives => ({
	list: {
		source: { client, collection: COLLECTION, map: record => record, connection },
		options: () => ({ sort: '-updated', perPage: 1 }),
	},
	record: {
		source: { client, collection: COLLECTION, map: fromRecord, connection },
		options: id => ({ filter: byId(id), perPage: 1 }),
	},
})

export { createKnowledgeLives }
